var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF06A",
    transform: "translate(0.375000, 0.375000)",
    fill: "#212529",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625,1.5 C8.8125,1.5 6.421875,2.4921875 4.453125,4.4765625 C2.484375,6.4609375 1.5,8.84375 1.5,11.625 C1.5,14.4375 2.4921875,16.828125 4.4765625,18.796875 C6.4609375,20.765625 8.84375,21.75 11.625,21.75 C14.4375,21.75 16.828125,20.7578125 18.796875,18.7734375 C20.765625,16.7890625 21.75,14.40625 21.75,11.625 C21.75,8.8125 20.7578125,6.421875 18.7734375,4.453125 C16.7890625,2.484375 14.40625,1.5 11.625,1.5 Z M3.375,3.421875 C5.65625,1.140625 8.40625,0 11.625,0 C14.84375,0 17.5859375,1.1328125 19.8515625,3.3984375 C22.1171875,5.6640625 23.25,8.40625 23.25,11.625 C23.25,14.84375 22.1171875,17.5859375 19.8515625,19.8515625 C17.5859375,22.1171875 14.84375,23.25 11.625,23.25 C8.40625,23.25 5.6640625,22.1171875 3.3984375,19.8515625 C1.1328125,17.5859375 0,14.84375 0,11.625 C0,8.40625 1.125,5.671875 3.375,3.421875 Z M11.109375,5.625 L12.140625,5.625 C12.328125,5.625 12.4765625,5.6796875 12.5859375,5.7890625 C12.6953125,5.8984375 12.734375,6.03125 12.703125,6.1875 L12.375,14.0625 C12.375,14.4375 12.1875,14.625 11.8125,14.625 L11.4375,14.625 C11.0625,14.625 10.875,14.4375 10.875,14.0625 L10.546875,6.1875 C10.515625,6.03125 10.5546875,5.8984375 10.6640625,5.7890625 C10.7734375,5.6796875 10.921875,5.625 11.109375,5.625 Z M10.6875,15.9375 C10.9375,15.6875 11.25,15.5625 11.625,15.5625 C12,15.5625 12.3125,15.6875 12.5625,15.9375 C12.8125,16.1875 12.9375,16.5 12.9375,16.875 C12.9375,17.25 12.8125,17.5625 12.5625,17.8125 C12.3125,18.0625 12,18.1875 11.625,18.1875 C11.25,18.1875 10.9375,18.0625 10.6875,17.8125 C10.4375,17.5625 10.3125,17.25 10.3125,16.875 C10.3125,16.5 10.4375,16.1875 10.6875,15.9375 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.63020df88162c8ae734a566fc86f3ec1.svg";
export { ForwardRef as ReactComponent };